import { parsePopupCustomTextCellKey } from "./popupCustomText";

/** The cell-review field path for a benefit row, network-qualified when the column has one. */
export const benefitFieldPath = (
  benefitKey: string,
  network?: string,
): string => (network ? `${benefitKey}::${network}` : benefitKey);

/**
 * Resolves the cell-review identity to stamp "Edited" when custom text is
 * saved. Custom text is persisted as a field override, outside AG Grid's
 * value-commit path, so onCellValueChanged never marks the cell dirty and the
 * coverage-change handler that stamps grid edits (PlanEditorContent) never
 * sees it. This derives the same (planId, fieldPath) pair that handler uses.
 */
export const resolveCustomTextEditedStamp = (
  cellKey: string,
): { planId: string; fieldPath: string } | undefined => {
  const identity = parsePopupCustomTextCellKey(cellKey);
  if (!identity) return undefined;

  return {
    planId: identity.benefitPlanId,
    fieldPath: benefitFieldPath(identity.benefitKey, identity.network),
  };
};
